import { __assign, __awaiter, __extends, __generator, __read } from "tslib";
import React from 'react';
import { LocaleProvider } from './LocaleProvider';
var devExtremeLoadPromise = null;
function ensureDevExtremeLoaded() {
    if (window.DevExpress) {
        return Promise.resolve();
    }
    if (!devExtremeLoadPromise) {
        devExtremeLoadPromise = import('@ekuaibao/datagrid/esm/load').then(function (_a) {
            var load = _a.load;
            return load();
        });
    }
    return devExtremeLoadPromise;
}
export function withLoader(loadFn) {
    var componentLoadPromise = null;
    var ensureComponentLoaded = function () {
        if (!componentLoadPromise) {
            componentLoadPromise = loadFn().then(function (d) { return d.default; });
        }
        return componentLoadPromise;
    };
    var Loader = (function (_super) {
        __extends(Loader, _super);
        function Loader() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.unmounted = false;
            _this.state = {
                loaded: false
            };
            return _this;
        }
        Loader.prototype.componentDidMount = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, DataGridWrapper;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4, Promise.all([ensureDevExtremeLoaded(), ensureComponentLoaded()])];
                        case 1:
                            _a = __read.apply(void 0, [_b.sent(), 2]), DataGridWrapper = _a[1];
                            this.DataGridWrapper = DataGridWrapper;
                            if (!this.unmounted) {
                                this.setState({
                                    loaded: true
                                });
                            }
                            return [2];
                    }
                });
            });
        };
        Loader.prototype.componentWillUnmount = function () {
            this.unmounted = true;
        };
        Loader.prototype.render = function () {
            if (!this.state.loaded) {
                return null;
            }
            return (React.createElement(LocaleProvider, null,
                React.createElement(this.DataGridWrapper, __assign({}, this.props))));
        };
        Loader.displayName = 'DevExtreme Loader';
        return Loader;
    }(React.PureComponent));
    ;
    Loader.preload = function () {
        return Promise.all([ensureDevExtremeLoaded(), ensureComponentLoaded()]).then(function (_a) {
            var _b = __read(_a, 2), DataGridWrapper = _b[1];
            return DataGridWrapper;
        });
    };
    return Loader;
}
export default withLoader;
